
























































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Index extends Vue {
  @Watch("$route", { immediate: true })
  onCatalogIdChange() {
    this.active = parseInt(this.$route.params.type) + 1;
    this.handleSelectTab(this.$route.params.type);
  }
  arrDom;
  tabList = [
    { id: 1, name: "合作模式" },
    { id: 2, name: "专家权益" },
    { id: 3, name: "常见问题" },
    { id: 4, name: "申请加入" },
    { id: 5, name: "合作流程" }
  ];
  TabFix = false;
  active = 0;
  offsetTop = 868;
  activeEnd = false;

  patternList = [
    { name: "教材编写", src: require("../../../assets/icon13.png") },
    { name: "授课教学", src: require("../../../assets/icon14.png") },
    { name: "演讲邀请", src: require("../../../assets/icon15.png") },
    { name: "顾问聘用", src: require("../../../assets/icon16.png") },
    { name: "专家咨询", src: require("../../../assets/icon17.png") },
    { name: "专项调研", src: require("../../../assets/icon18.png") },
    { name: "专业评审", src: require("../../../assets/icon19.png") },
    { name: "课程合作", src: require("../../../assets/icon20.png") }
  ];

  // username: "sdf",
  // sex: "1",
  // nationality: "sdf",
  // city: "sdf",
  // year: "sdf",
  // phone: { val: "xcv", err: false },
  // email: { val: "dsf", err: false },
  // agree: false,
  // field: "sdf",
  // experience: [
  //   {
  //     title: "dsf",
  //     content1: "fdg",
  //     content2: "fdg",
  //     content3: "dfg"
  //   },
  //   {
  //     title: "",
  //     content1: "",
  //     content2: "",
  //     content3: ""
  //   },
  //   {
  //     title: "",
  //     content1: "",
  //     content2: "",
  //     content3: ""
  //   },
  //   {
  //     title: "",
  //     content1: "",
  //     content2: "",
  //     content3: ""
  //   }
  // ],
  // experienceArr: [],
  // education: [
  //   {
  //     title: "fdg",
  //     content4: "dfg",
  //     content5: "dfg",
  //     content6: "dfg"
  //   },
  //   {
  //     title: "",
  //     content4: "",
  //     content5: "",
  //     content6: ""
  //   },
  //   {
  //     title: "",
  //     content4: "",
  //     content5: "",
  //     content6: ""
  //   },
  //   {
  //     title: "",
  //     content4: "",
  //     content5: "",
  //     content6: ""
  //   }
  // ],
  // educationArr: []
  created() {
    // this.sex = 0;
  }
  mounted() {
    //记录每个内容对用的dom数组
    this.arrDom = document.getElementsByClassName("TabContent");
    window.addEventListener("scroll", this.handleScroll);
    this.active = parseInt(this.$route.params.type) + 1;
    this.handleSelectTab(this.$route.params.type);
  }

  coursePartner(i) {
    if (i == this.patternList.length - 1) {
      this.$router.push({ path: "/partner/course/1" });
    }
  }
  handleScroll(e) {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.TabFix = scrollTop > this.offsetTop;
    for (let i = 0; i < this.arrDom.length; i++) {
      //因为下面使用到了i+1，所以需要把最后一个分离出来判断
      if (this.arrDom[this.arrDom.length - 1].offsetTop - scrollTop > 80) {
        if (
          this.arrDom[i].offsetTop - scrollTop <= 80 &&
          this.arrDom[i + 1].offsetTop - scrollTop > 80
        ) {
          this.active = i + 1;
        } else {
          //
        }
      } else {
        this.active = this.arrDom.length;
      }
    }
  }

  handleSelectTab(id) {
    for (let i = 0; i < this.tabList.length; i++) {
      if (i + 1 == id) {
        this.arrDom[i].scrollIntoView({
          behavior: "smooth",
          block: "start" // 上边框与视窗顶部平齐。默认值
        });
        document.documentElement.scrollTop = this.arrDom[i].offsetTop - 80;
      }
    }
    this.active = id;
  }
  subcen() {
    // this.mask = false;
  }
  subinfo() {
    // if (this.tname == "") {
    //   this.$message("请输入姓名");
    //   return false;
    // } else if (this.temail == "") {
    //   this.$message("请输入邮箱");
    //   return false;
    // } else if (this.tbname == "") {
    //   this.$message("请输入被推荐人姓名");
    //   return false;
    // } else if (this.tbcomp == "") {
    //   this.$message("请输入被推荐人公司名称");
    //   return false;
    // } else if (this.tbsi == "") {
    //   this.$message("请输入被推荐人职务");
    //   return false;
    // } else if (this.tbtel == "") {
    //   this.$message("请输入被推荐人手机号码");
    //   return false;
    // } else if (this.tbinf == "") {
    //   this.$message("请输入被推荐人简介");
    //   return false;
    // } else {
    //   const url = this.$store.state.homeUrl;
    //   this.$ajax
    //     .get(url + "/webAction/addRecommender", {
    //       params: {
    //         field1: this.tname,
    //         field2: this.temail,
    //         field3: this.tbname,
    //         field4: this.tbcomp,
    //         field5: this.tbsi,
    //         field6: this.tbtel,
    //         content1: this.tbinf,
    //         isShow: parseInt(this.radiosdf)
    //       }
    //     })
    //     .then(function(res) {
    //       // console.log(res);
    //       if (res.data.code == 1) {
    //         // this.$message(res.data.msg);
    //         // this.mask = false;
    //       }
    //     });
    // }
  }
  subInfo() {
    // console.log(this.sex)
    // const url = this.$store.state.homeUrl;
    // if (this.agree) {
    //   const that = this;
    //   //学历/专业资格
    //   // that.educationArr = [];
    //   for (let i = 0; i < this.education.length; i++) {
    //     if (
    //       this.education[i].title != "" &&
    //       this.education[i].content4 != "" &&
    //       this.education[i].content5 &&
    //       this.education[i].content6
    //     ) {
    //       that.educationArr.push(this.education[i]);
    //     }
    //   }
    //
    //   //工作经历
    //   that.experienceArr = [];
    //   for (let i = 0; i < this.experience.length; i++) {
    //     if (
    //       this.experience[i].title != "" &&
    //       this.experience[i].content1 != "" &&
    //       this.experience[i].content2 &&
    //       this.experience[i].content3
    //     ) {
    //       that.experienceArr.push(this.experience[i]);
    //     }
    //   }
    //
    //   // console.log("sfdsf" + that.educationArr);
    //   // console.log(JSON.stringify(that.educationArr));
    //   if (this.username == "") {
    //     this.$message("请输入姓名");
    //   } else if (this.nationality == "") {
    //     this.$message("请输入国籍/民族");
    //   } else if (this.city == "") {
    //     this.$message("请输入现定居城市");
    //   } else if (this.year == "") {
    //     this.$message("请输入出生年月");
    //   } else if (this.phone.val == "") {
    //     this.$message("请输入手机号码");
    //   } else if (this.email.val == "") {
    //     this.$message("请输入Email");
    //   } else if (that.educationArr.length == 0) {
    //     this.$message("请输入Email");
    //     console.log("请输入学历/专业资格");
    //   } else if (that.experienceArr.length == 0) {
    //     console.log("请输入主要工作经历");
    //   } else if (this.field == "") {
    //     console.log("请输入专业领域");
    //   } else {
    //     const s = {
    //       field1: this.username,
    //       field2: this.nationality,
    //       reading: parseInt(this.sex),
    //       field3: this.city,
    //       field4: this.phone.val,
    //       field5: this.email.val,
    //       field6: this.year,
    //       content1: JSON.stringify(that.educationArr),
    //       content2: JSON.stringify(that.experienceArr),
    //       content3: this.field
    //     };
    //     // console.log(JSON.stringify(s))
    //     this.$ajax
    //       .get("http://122.112.150.70/webAction/addExpert", { params: s })
    //       .then(function(res) {
    //         if (res.data.code == 1) {
    //           //
    //         }
    //       })
    //       .catch(function(error) {
    //         //
    //       });
    //   }
    // } else {
    //   this.$message("请勾选");
    // }
  }
  add() {
    // const arr = {
    //   time: "",
    //   school: "",
    //   educations: "",
    //   certificate: ""
    // };
    // this.education.push(arr);
  }
  phoneTest() {
    // const reg = /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/;
    // const that = this;
    // if (
    //   that.phone.val == "" ||
    //   that.phone.val.length <= 10 ||
    //   !reg.test(that.phone.val)
    // ) {
    //   that.phone.err = true;
    //   that.$message({
    //     message: "手机号码错误",
    //     type: "error"
    //   });
    //   that.phone.val = "";
    //   return false;
    // } else {
    //   that.phone.err = false;
    //   return true;
    // }
  }
  emailTest() {
    //   const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    //   const that = this;
    //   if (that.email.val != "" && !regEmail.test(that.email.val)) {
    //     that.$message({
    //       message: "邮箱格式不正确",
    //       type: "error"
    //     });
    //     that.email.val = "";
    //   } else {
    //     that.email.err = false;
    //   }
  }
}
